.popover {
  position: fixed;
  z-index: 50;
  /* The content sets its own width (the picker is 320/360px, 2026-10b §5.3). */
  width: max-content;
  min-width: 260px;
  max-width: calc(100vw - 16px);
  max-height: calc(100dvh - 16px);
  overflow-y: auto;
  padding: 12px;
  background: var(--surface);
  /* Accent border and ring: a floating panel must not read as one more page card. */
  border: 1px solid var(--accent);
  border-radius: var(--radius);
  box-shadow:
    0 0 0 3px var(--accent-soft-strong),
    var(--shadow-pop);
  outline: none;
}
